import { render } from "./ActuView.vue?vue&type=template&id=a4ce30a2&scoped=true"
import script from "./ActuView.vue?vue&type=script&lang=js"
export * from "./ActuView.vue?vue&type=script&lang=js"

import "./ActuView.vue?vue&type=style&index=0&id=a4ce30a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4ce30a2"]])

export default __exports__